
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75.75h15v18h-15Zm15 13.5h-15","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m18.755 6.231 3.982 1.327a.75.75 0 0 1 .474.949l-4.743 14.23a.75.75 0 0 1-.949.474l-6.269-2.089M5.625 6.375a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0ZM3.75 14.25a4.5 4.5 0 0 1 9 0Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    